<template>
  <div>
    <v-row v-if="selectedImage && selectedImage.url">
      <div>
        <v-row>
          <v-col>
            <v-icon>
              mdi-image
            </v-icon>
          </v-col>

          <v-col>
            <v-img :src="value.url"
                   height="200"
                   width="300"
                   label="Image"
                   class="rounded-xl"
            >
            </v-img>

            <div>
              <v-btn
                  rounded
                  class="mt-2 mb-10 float-right"
                  @click="clearImage"
              >
                <v-card-text class="primary--text">
                  Replace image
                </v-card-text>

                <v-icon small color="primary">
                  mdi-close-circle-outline
                </v-icon>

              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-row>
    <v-row class="mb-5" v-else>
      <v-autocomplete
          aria-required="true"
          color="primary"
          label="Choose an image to associate with this item"
          placeholder="Start typing to find an image"
          prepend-icon="mdi-image"
          flat
          solo
          clearable
          :items="images"
          :loading="imagesLoading"
          :search-input.sync="search"
          :value="value"
          hide-no-data
          hide-selected
          item-text="originalName"
          item-value="_id"
          return-object
          @input="onInput"
      >
        <template v-slot:item="{ item }">
          <v-row class="my-1">
            <v-col cols="2" class="pl-14">
              <v-img
                  :src="item.url"
                  height="50"
                  width="85"
                  class="rounded"
              ></v-img>
            </v-col>

            <v-col>
              <div v-html="item.originalName"></div>

              <div v-html="item.alt" class="text-caption"></div>
            </v-col>
          </v-row>
        </template>
      </v-autocomplete>
    </v-row>
  </div>
</template>

<script>

/**
 * Instructions for adding to other templates
 * @example <ImagePicker v-model="image"/>
 * @param {object} v-model The object that you want to store the image
 */

import { mapActions, mapGetters } from "vuex";

export default {
  name: "ImagePicker",
  data: () => ({
    isLoading: false,
    search: '',
  }),
  computed: {
    ...mapGetters(['images', 'imagesLoading']),
    selectedImage() {
      return this.value;
    },
  },
  methods: {
    ...mapActions([
        'getImages', 'setImagesSearch',
    ]),
    clearImage() {
      this.onInput({});
    },
    onInput(image) {
      let selectedImage = {};
      if (image.url) {
        selectedImage = {
          url: image.url,
          alt: image.alt,
          ref: image._links[0].href,
        };
      }

      this.$emit('input', selectedImage);
    },
  },
  props: {
    value: {
      type: Object,
    },
  },
  watch: {
    search(val) {
      this.setImagesSearch(val);
      this.getImages();
    },
  },
};
</script>
